/** Runtime theme filled after public theme API fetch; CSS vars applied on :root separately. */

let _tokens = {};
let _mapBackgroundColor = "#f5f3ef";

export function setRuntimeTokens(tokens) {
  _tokens = tokens && typeof tokens === "object" ? { ...tokens } : {};
  if (_tokens.map_background_color) {
    _mapBackgroundColor = String(_tokens.map_background_color);
  }
}

export function getThemeToken(key, fallback) {
  const v = _tokens[key];
  return v != null && v !== "" ? v : fallback;
}

export function getRuntimeMapBackground() {
  return _mapBackgroundColor;
}

export function getRawTokens() {
  return { ..._tokens };
}
